<!-- <main class="auth-page">
  <section class="auth-card">
    <a routerLink="/" class="logo">MeuCardápio</a>

    <h1>Criar conta</h1>
    <p>Cadastre-se para acompanhar seus pedidos.</p>

    <label>Nome</label>
    <input [(ngModel)]="form.name" placeholder="Seu nome">

    <label>E-mail</label>
    <input [(ngModel)]="form.email" type="email" placeholder="seuemail@email.com">

    <label>Telefone</label>
    <input [(ngModel)]="form.phone" placeholder="WhatsApp">

    <label>Senha</label>
    <input [(ngModel)]="form.password" type="password" placeholder="Crie uma senha">

    <button [disabled]="loading" (click)="register()">
      {{ loading ? 'Criando...' : 'Criar conta' }}
    </button>

    <div class="error" *ngIf="error">{{ error }}</div>

    <p class="link">
      Já tem conta?
      <a routerLink="/customer/login">Entrar</a>
    </p>
  </section>
</main> -->



<main class="auth-page">

  <section class="auth-shell">

    <div class="auth-brand">

      <a routerLink="/" class="logo">
        <span class="logo-mark">
          🍽️
        </span>

        <span>
          MeuCardápio
        </span>
      </a>

      <div class="brand-content">

        <span class="brand-tag">
          Sua experiência começa aqui.
        </span>

        <h2>
          Crie sua conta e acompanhe
          seus pedidos com facilidade.
        </h2>

        <p>
          Cadastre-se em poucos segundos para acompanhar pedidos,
          acessar seu histórico e aproveitar melhor sua experiência
          no restaurante.
        </p>

      </div>

      <div class="brand-decoration">

        <div class="decoration-card">
          <span>📱</span>
          <strong>Cadastro rápido</strong>
          <small>Leva apenas alguns segundos</small>
        </div>

        <div class="decoration-card">
          <span>🧾</span>
          <strong>Seus pedidos</strong>
          <small>Acompanhe tudo em um só lugar</small>
        </div>

      </div>

    </div>


    <section class="auth-card">

      <div class="mobile-logo">

        <a routerLink="/" class="logo">

          <span class="logo-mark">
            🍽️
          </span>

          <span>
            MeuCardápio
          </span>

        </a>

      </div>


      <div class="auth-header">

        <span class="eyebrow">
          Área do cliente
        </span>

        <h1>
          Criar sua conta
        </h1>

        <p>
          Preencha seus dados para acompanhar seus pedidos.
        </p>

      </div>


      <div
        class="error"
        *ngIf="error"
      >

        <span class="error-icon">
          !
        </span>

        <span>
          {{ error }}
        </span>

      </div>


      <!-- NOME -->

      <div class="form-field">

        <label for="customer-name">
          Nome
        </label>

        <div class="input-wrapper">

          <span class="input-icon">
            👤
          </span>

          <input
            id="customer-name"
            [(ngModel)]="form.name"
            type="text"
            autocomplete="name"
            placeholder="Seu nome"
          >

        </div>

      </div>


      <!-- EMAIL -->

      <div class="form-field">

        <label for="customer-email">
          E-mail
        </label>

        <div class="input-wrapper">

          <span class="input-icon">
            ✉
          </span>

          <input
            id="customer-email"
            [(ngModel)]="form.email"
            type="email"
            autocomplete="email"
            placeholder="seuemail@email.com"
          >

        </div>

      </div>


      <!-- TELEFONE -->

      <div class="form-field">

        <label for="customer-phone">
          Telefone
        </label>

        <div class="phone-wrapper">

          <div class="phone-prefix">
            <span class="flag">
              🇧🇷
            </span>

            <span>
              +55
            </span>
          </div>

          <input
            id="customer-phone"
            type="tel"
            inputmode="numeric"
            autocomplete="tel"
            [(ngModel)]="form.phone"
            (ngModelChange)="onPhoneChange($event)"
            placeholder="(81) 99999-9999"
            maxlength="15"
          >

        </div>

      </div>


      <!-- SENHA -->

      <div class="form-field">

        <label for="customer-password">
          Senha
        </label>

        <div class="input-wrapper">

          <span class="input-icon">
            🔒
          </span>

          <input
            id="customer-password"
            [(ngModel)]="form.password"
            type="password"
            autocomplete="new-password"
            placeholder="Crie uma senha"
            (keyup.enter)="register()"
          >

        </div>

      </div>


      <button
        type="button"
        class="register-button"
        [disabled]="loading"
        (click)="register()"
      >

        <span *ngIf="!loading">
          Criar conta
        </span>

        <span
          class="loading-button"
          *ngIf="loading"
        >
          <span class="spinner"></span>

          Criando...
        </span>

      </button>


      <div class="separator">

        <span>
          ou
        </span>

      </div>


      <div class="login-box">

        <div>

          <strong>
            Já possui uma conta?
          </strong>

          <span>
            Entre para continuar seus pedidos.
          </span>

        </div>

        <a
          routerLink="/customer/login"
          class="login-link"
        >
          Entrar
        </a>

      </div>


      <p class="auth-footer">
        Seus dados são utilizados apenas para sua experiência
        dentro do MeuCardápio.
      </p>

    </section>

  </section>

</main>